import StyledHeader from '/business/shared/components/widgets/header/__styled__/StyledHeader';
import HeaderLogo from '/business/shared/components/widgets/header/HeaderLogo';

function MiscLayoutHeader() {
  return (
    <StyledHeader>
      <HeaderLogo />
    </StyledHeader>
  );
}

export default MiscLayoutHeader;
